<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { DOCUMENT_STATUS_CLASSES, documentStatusLabel } from '../constants';

const props = defineProps({ status: { type: String, required: true } });
const { t, te } = useI18n();

const label = computed(() => documentStatusLabel(props.status, t, te));
</script>

<template>
  <span
    class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium"
    :class="DOCUMENT_STATUS_CLASSES[status] || DOCUMENT_STATUS_CLASSES.draft"
  >
    {{ label }}
  </span>
</template>
